import { SwUpdate } from '@angular/service-worker';
import { Injectable } from '@angular/core';

@Injectable()
export class LogUpdateService {

  constructor(updates: SwUpdate) {
    if (!updates.isEnabled) {

    } else {
      updates.versionUpdates.subscribe(event => {
        if (event.type === 'VERSION_DETECTED') {
          // New version available
        } else if (event.type === 'VERSION_READY') {
          // New version activated
        }
      });

    }
  }
}
